import {Component, ViewContainerRef} from "@angular/core";
import {Router} from '@angular/router';
import {PermissionHelper} from 'app/shared/permissions/permissions';
import {Configuration, HttpClientCustom} from 'app/shared';
import {TranslateService} from '@ngx-translate/core';
import {ToasterComponent} from 'app/toasterComponent/toasterComponent';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SharedData} from 'app/shared/sharedData';

@Component({
    selector: 'add-operation',
    templateUrl: 'addOperation.component.html'
})

export class AddOperationComponent {

    public _baseUrl: any;
    public operationList: any [];
    public operationDetailsData: any;
    public isUpdate: boolean = false;

    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate: TranslateService,
        public _toaster: ToasterComponent,
        vcr: ViewContainerRef,
        public activeModal: NgbActiveModal,
        public share: SharedData
    ) {
        let self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
        let shareData = self.share.getData();
        if (shareData.hasOwnProperty('operationDetailsData')) {
            this.operationDetailsData = shareData['operationDetailsData'];
        }
        self.getOperationList();
    }

    public getOperationList() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/operationDetails/operationList';
        self.http.get(url).subscribe((result) => {
            self.operationList = result;
        }, (error) => {
            console.log('Error:', error);
        })
    }

    public save() {
        if (!this.operationDetailsData.name.trim() || !this.operationDetailsData.externalURL.trim()) {
            this.translate.get('mandNotEmpty').subscribe((msg) => {
                this._toaster.showError(msg);
            });
        } else {
            let self = this;
            let url = self._baseUrl + 'v1/webAdmin/operationDetails';
            self.http.post(url, self.operationDetailsData).subscribe((result: any) => {
                if (result.success) {
                    self.translate.get('operationDetailsSaved').subscribe((msg) => {
                        self._toaster.showSuccess(msg);
                        self.activeModal.close();
                    });
                } else {
                    self.translate.get(result.errorMessage).subscribe((msg) => {
                        self._toaster.showError(msg);
                        self.activeModal.close();
                    });
                }
            });
        }
    }

    public fileChange(event) {
        console.log(event);

        const fileList: FileList = event.target.files;
        let result: any;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            const fileName = file.name;
            const path = event.target.value;
            const reader = new FileReader();
            reader.onloadend = (e: any) => {
                result = e.target.result;
                this.getAllData(path, fileName, result);
            };
            reader.readAsBinaryString(file);
        }
    }

    public getAllData(path, fileNames, result) {
        const a = path.split("/");
        const fileName = a.pop();
        const fileNameArray = fileName.split(".");
        const ext = fileNameArray[1];

        this.operationDetailsData.attachment = {
            docName: fileNames,
            docType: ext,
            document: window.btoa(result),
            docId: null
        };
    }

    public cancel() {
        let self = this;
        self.activeModal.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/tools/operations/addOperation.component.ts